import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.2267 9.89332C11.7315 9.13505 12.0006 8.24429 12 7.33332C12.0014 6.2947 11.6562 5.28531 11.0192 4.46497C10.3822 3.64464 9.48976 3.06025 8.48316 2.80434C7.47657 2.54843 6.41337 2.63563 5.46192 3.05213C4.51047 3.46863 3.72516 4.19063 3.23033 5.1038C2.73551 6.01696 2.55945 7.06911 2.73004 8.09362C2.90063 9.11813 3.40812 10.0565 4.17214 10.76C4.93617 11.4636 5.91306 11.8921 6.94813 11.9779C7.9832 12.0636 9.0173 11.8016 9.88666 11.2333L12 13.3333L13.3333 12L11.2267 9.89332ZM3.99999 7.33332C3.99999 6.67405 4.19549 6.02958 4.56176 5.48142C4.92803 4.93325 5.44863 4.50601 6.05771 4.25372C6.6668 4.00143 7.33702 3.93541 7.98363 4.06403C8.63023 4.19265 9.22417 4.51012 9.69035 4.97629C10.1565 5.44247 10.474 6.03641 10.6026 6.68302C10.7312 7.32962 10.6652 7.99984 10.4129 8.60893C10.1606 9.21802 9.73339 9.73861 9.18523 10.1049C8.63706 10.4712 7.9926 10.6667 7.33333 10.6667C6.44927 10.6667 5.60142 10.3155 4.9763 9.69034C4.35118 9.06522 3.99999 8.21737 3.99999 7.33332Z","fill":"currentColor"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
